export default __webpack_public_path__ + "9d6f2daaba0c61e6de50e8bbb88e4684.svg";